import { render, staticRenderFns } from "./ConceptBooth.vue?vue&type=template&id=ccc09484&scoped=true"
import script from "./ConceptBooth.vue?vue&type=script&lang=js"
export * from "./ConceptBooth.vue?vue&type=script&lang=js"
import style0 from "./ConceptBooth.vue?vue&type=style&index=0&id=ccc09484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc09484",
  null
  
)

export default component.exports